import React from 'react';
import sseNotificationService from '../services/SseNotificationService';
import { toast } from 'react-toastify';
import request from './utils/request';
import { urls } from '../constants/app';
import connectionToastManager from '../utils/connectionToastManager';
import moment from 'moment';
import { isEmpty } from 'lodash';

let audioElement = null;
let audioUnlocked = false;
let activeToastCount = 0;

function getAudioElement() {
  if (!audioElement) {
    audioElement = new Audio('/oh-oh-icq-sound.mp3');
  }
  return audioElement;
}

function unlockAudio() {
  if (audioUnlocked) return;
  const audio = getAudioElement();
  audio.volume = 0;
  audio.play().then(() => {
    audio.pause();
    audio.currentTime = 0;
    audioUnlocked = true;
    document.removeEventListener('click', unlockAudio);
    document.removeEventListener('keydown', unlockAudio);
  }).catch(() => {});
}

export function initializeNotifications() {
  return (dispatch, getState) => {
    document.addEventListener('click', unlockAudio);
    document.addEventListener('keydown', unlockAudio);

    sseNotificationService.on('status_change', (status) => {
      dispatch({
        type: 'SET_CONNECTION_STATUS',
        status
      });

      connectionToastManager.showConnectionStatus(status);
    });

    sseNotificationService.on('new_order', (data) => {
      dispatch(handleNewOrderNotification(data));
    });

    sseNotificationService.on('order_point_changed', (data) => {
      dispatch(handleOrderPointChange(data));
    });

    sseNotificationService.on('connected', () => {
      toast.success('Подключение к серверу установлено', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: true,
      });
    });

    sseNotificationService.connect();
  };
}

function loadFullOrderData(orderId, dispatch, getState) {
  request({ method: 'get', url: `${urls.orders}/crm`, params: { id: orderId } })
    .then(async (response) => {
      if (response && response.length > 0) {
        const fullOrder = response[0];
        const state = getState();
        const cities = state.handbook.cities;
        const zones = state.handbook.zones;
        const user = state.user.info;

        if(fullOrder.city && !fullOrder.city.id) {
          let checkCity = cities && cities.find((city) => city.id === fullOrder.city);
          if(checkCity) {
            fullOrder.city = checkCity;
          } else {
            try {
              const cityResponse = await request({ method: 'get', url: `${urls.cities}/${fullOrder.city}` });
              fullOrder.city = cityResponse;
            } catch (e) {
              console.error('[Notifications] Failed to load city:', e);
            }
          }
        }

        if(fullOrder.point && !fullOrder.point.id) {
          let checkPoint = user && user.points && user.points.find((point) => point.id === fullOrder.point);
          if(checkPoint) {
            fullOrder.point = checkPoint;
          } else {
            try {
              const pointResponse = await request({ method: 'get', url: `${urls.filials}/${fullOrder.point}` });
              fullOrder.point = pointResponse;
            } catch (e) {
              console.error('[Notifications] Failed to load point:', e);
            }
          }
        }

        if(fullOrder.zone && !fullOrder.zone.id) {
          let checkZone = zones && zones.find((zone) => zone.id === fullOrder.zone);
          if(checkZone) {
            fullOrder.zone = checkZone;
          } else {
            try {
              const zoneResponse = await request({ method: 'get', url: `${urls.zone}/${fullOrder.zone}` });
              fullOrder.zone = zoneResponse;
            } catch (e) {
              console.error('[Notifications] Failed to load zone:', e);
            }
          }
        }

        if (fullOrder.goods) {
          try {
            fullOrder.goods = typeof fullOrder.goods === 'string'
              ? JSON.parse(fullOrder.goods)
              : fullOrder.goods;
          } catch (e) {
            console.error('[Notifications] Failed to parse goods:', e);
            fullOrder.goods = [];
          }
        } else {
          fullOrder.goods = [];
        }

        ['paymentData', 'cashback', 'aggData', 'tags'].forEach(field => {
          if (fullOrder[field]) {
            try {
              fullOrder[field] = typeof fullOrder[field] === 'string'
                ? JSON.parse(fullOrder[field])
                : fullOrder[field];
            } catch (e) {
              console.error(`[Notifications] Failed to parse ${field}:`, e);
            }
          }
        });

        dispatch({
          type: 'UPDATE_ORDER_TABLE',
          id: fullOrder.id,
          data: fullOrder
        });
      }
    })
    .catch(error => {
      console.error('[Notifications] Failed to load full order data:', error);
    });
}

const getMatchesFilter = (currentFilter, order, newPointId) => {
  if (currentFilter && !isEmpty(currentFilter)) {
    if (currentFilter.id) return false;

    let pointId = null;
    if (newPointId) {
      pointId = newPointId;
    } else if (order.point) {
      if (order.point.id) {
        pointId = order.point.id;
      } else {
        pointId = order.point;
      }
    } else if (order.zone) {
      if (order.zone.point.id) {
        pointId = order.zone.point.id;
      } else {
        pointId = order.zone.point;
      }
    }
    const pointsValues = (currentFilter.points && currentFilter.points.length > 0) ? currentFilter.points.map((item) => parseInt(item.value)).filter((item) => item) : null;
    const matchesPoint = !pointsValues || pointsValues.length === 0 || pointsValues.includes(parseInt(pointId));
    if (!matchesPoint) return false;

    const orderCityId = order.city ? order.city.id ? order.city.id : order.city : null;
    const citiesValues = (currentFilter.cities && currentFilter.cities.length > 0) ? currentFilter.cities.map((item) => parseInt(item.value)).filter((item) => item) : null;
    const matchesCity = !citiesValues || citiesValues.length === 0 || citiesValues.includes(parseInt(orderCityId));
    if (!matchesCity) return false;

    const statusesValues = (currentFilter.statuses && currentFilter.statuses.length > 0) ? currentFilter.statuses.map((item) => item.value).filter((item) => item) : null;
    const matchesStatus = !statusesValues || statusesValues.length === 0 || statusesValues.includes(order.status);
    if (!matchesStatus) return false;

    const time = parseInt(order.timeZone, 10) || 3;
    const baseOrderDate = order.visible_datetime || order.created_at;
    
    const currentOrderDate = moment.utc(baseOrderDate).add(time, 'hours');

    const createdStartDate = (currentFilter && currentFilter.createdStartDate) ? moment(currentFilter.createdStartDate) : null;
    const createdEndDate = (currentFilter && currentFilter.createdEndDate) ? moment(currentFilter.createdEndDate) : null;

    let matchesDate = true;

    if (currentOrderDate) {
      if (createdStartDate && createdEndDate) {
        matchesDate = currentOrderDate.isBetween(createdStartDate, createdEndDate, null, '[]');
      } else {
        if (createdStartDate) matchesDate = currentOrderDate.isSameOrAfter(createdStartDate);
        if (createdEndDate) matchesDate = currentOrderDate.isSameOrBefore(createdEndDate);
      }
    }

    if (!matchesDate) return false;

    const matchesPhone = currentFilter.phone ? String(order.phone) === String(currentFilter.phone) : true;
    if (!matchesPhone) return false;

    const matchesPayment = !currentFilter.payment || !currentFilter.payment.value || currentFilter.payment.value === order.payment;
    if (!matchesPayment) return false;

    if (currentFilter.courier && currentFilter.courier.value) return false;

    const matchesName = !currentFilter.name || (order.userName && order.userName.toLowerCase().includes(currentFilter.name.toLowerCase()));
    if (!matchesName) return false;

    const matchesZone = !currentFilter.zone || !!order.zone;
    if (!matchesZone) return false;

    let matchesConsumption = true;
    if (currentFilter.consumption) {
      matchesConsumption = false;
      switch (currentFilter.consumption) {
        case 'consumption':
          if (order.isConsumption === true && (!order.consumptionStatus || order.consumptionStatus === 'done')) matchesConsumption = true;
          break;
        case 'notConsumption':
          if (!order.isConsumption && !order.consumptionStatus) matchesConsumption = true;
          break;
        case 'processing':
          if (order.consumptionStatus && ['processing', 'processingReturn'].includes(order.consumptionStatus)) matchesConsumption = true;
          break;
        case 'error':
          if (order.consumptionStatus && ['error', 'errorReturn'].includes(order.consumptionStatus)) matchesConsumption = true;
          break;
        default: 
          matchesConsumption = true;
          break;
      }
    }

    if (!matchesConsumption) return false;

    return true;
  }
  return true;
}

export function ensureCloseAllButton() {
  activeToastCount--;
  if(activeToastCount < 1) {
    closeAllToasts()
  }
}

export function closeAllToastsBtn() {
  activeToastCount++
  toast(<strong>Очистить все</strong>, {
        toastId: 'closeAll',
        position: 'top-right',
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        style: {
          padding: '4px 8px',
          fontSize: '14px',
          textAlign: 'center',
          minHeight: '32px',
        },
        onClick: () => closeAllToasts(),
      })
}

export function closeAllToasts() {
  toast.dismiss()
  toast.clearWaitingQueue();
  activeToastCount = 0;
}

export function handleNewOrderNotification(data) {
  return (dispatch, getState) => {
    const { notifications } = getState();
    const { order } = data;

    const orderExists = getState().orders.list.some(o => o.id === order.id);
    if (orderExists) return;

    const currentFilter = getState().orders.filters;
    const matchesFilter = getMatchesFilter(currentFilter, order);
    if (!matchesFilter) return;

    try {
      const audio = getAudioElement();
      audio.volume = notifications.volume;
      audio.currentTime = 0;
      audio.play().catch(err => {
        console.warn('[Notifications] Audio playback failed:', err.message);
      });
    } catch (err) {
      console.error('[Notifications] Audio error:', err);
    }

    const toastMessage = (
      <div>
        <strong>Новый заказ #{order.id}</strong>
        <br />
        <small>
          Сумма: {order.totalPrice}₽
          {order.phone && ` • ${order.phone}`}
        </small>
      </div>
    );

    closeAllToastsBtn()

    toast.success(toastMessage, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      onClose: ensureCloseAllButton,
    });

    if (notifications.desktopEnabled && typeof Notification !== 'undefined') {
      if (Notification.permission === 'granted') {
        try {
          const notification = new Notification(`Новый заказ #${order.id}`, {
            body: `Сумма: ${order.totalPrice}₽\nТелефон: ${order.phone || 'Не указан'}`,
            icon: '/favicon.ico',
            tag: `order-${order.id}`,
            requireInteraction: false,
            silent: false
          });

          setTimeout(() => notification.close(), 10000);

          notification.onclick = () => {
            window.focus();
            notification.close();
          };
        } catch (err) {
          console.error('[Notifications] Desktop notification error:', err);
        }
      } else if (Notification.permission === 'default') {
        console.warn('[Notifications] Desktop notifications not yet permitted');
      }
    }

    dispatch({
      type: 'ADD_NEW_ORDER',
      order: order
    });

    loadFullOrderData(order.id, dispatch, getState);
  };
}

export function handleOrderPointChange(data) {
  return (dispatch, getState) => {
    const { newPointId, order } = data;
    const orderId = typeof data.orderId === 'string' ? parseInt(data.orderId, 10) : data.orderId;
    const state = getState();
    const user = state.user.info;

    if (!user || !orderId) return;
    const isAdmin = user.role && [4, 20].includes(user.role.id);
    const hasAllPoints = !!user.allPoints;
    const userPointIds = (user.points || []).map(p => p.id);
    const currentFilter = state.orders.filters;

    const hasAccessToNew = isAdmin || hasAllPoints || userPointIds.includes(newPointId);

    const matchesFilter = getMatchesFilter(currentFilter, order, newPointId);
    
    const shouldShow = hasAccessToNew && matchesFilter;

    const orderInList = state.orders.list.some(o => o.id === orderId);

    if (orderInList && shouldShow) {
      dispatch({ type: 'UPDATE_ORDER_TABLE', id: orderId, data: { point: order.point, city: order.city } });

    } else if (orderInList && !shouldShow) {
      dispatch({ type: 'REMOVE_ORDER_FROM_LIST', orderId });

    } else if (!orderInList && shouldShow) {
      dispatch({ type: 'ADD_NEW_ORDER', order });

      try {
        const audio = getAudioElement();
        const { notifications } = getState();
        audio.volume = notifications.volume;
        audio.currentTime = 0;
        audio.play().catch(() => {});
      } catch (err) { /* ignore */ }

      closeAllToastsBtn()
      
      toast.info(
        <div>
          <strong>Заказ #{order.id} переведён в ваш филиал</strong>
          <br />
          <small>Сумма: {order.totalPrice}₽{order.phone && ` • ${order.phone}`}</small>
        </div>,
        { position: 'top-right', autoClose: 5000, closeOnClick: true, pauseOnHover: true, onClose: ensureCloseAllButton }
      );

      loadFullOrderData(orderId, dispatch, getState);
    }
  };
}

export function notifyAboutNewOrder(order) {
  return (dispatch, getState) => {
    const { notifications } = getState();

    try {
      const audio = getAudioElement();
      audio.volume = notifications.volume;
      audio.currentTime = 0;
      audio.play().catch(err => {
        console.warn('[Notifications] Audio playback failed:', err.message);
      });
    } catch (err) {
      console.error('[Notifications] Audio error:', err);
    }

    closeAllToastsBtn()

    toast.success(
      <div>
        <strong>Новый заказ #{order.id}</strong>
        <br />
        <small>
          Сумма: {order.totalPrice}₽
          {order.phone && ` • ${order.phone}`}
        </small>
      </div>,
      {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: ensureCloseAllButton,
      }
    );
  };
}

export function updateNotificationPreferences(preferences) {
  return (dispatch) => {
    dispatch({
      type: 'SET_NOTIFICATION_PREFERENCES',
      preferences
    });
  };
}

export function requestNotificationPermission() {
  return async (dispatch) => {
    if (typeof Notification === 'undefined') {
      console.warn('[Notifications] Browser does not support desktop notifications');
      toast.warn('Ваш браузер не поддерживает уведомления');
      return false;
    }

    if (Notification.permission === 'granted') {
      return true;
    }

    if (Notification.permission === 'denied') {
      console.warn('[Notifications] Permission denied');
      toast.error('Уведомления заблокированы. Разрешите их в настройках браузера.');
      return false;
    }

    try {
      const permission = await Notification.requestPermission();

      if (permission === 'granted') {
        dispatch(updateNotificationPreferences({ desktopEnabled: true }));
        toast.success('Уведомления разрешены!');
        return true;
      } else {
        toast.warn('Уведомления не разрешены');
        return false;
      }
    } catch (err) {
      console.error('[Notifications] Permission request error:', err);
      toast.error('Ошибка при запросе разрешения на уведомления');
      return false;
    }
  };
}

export function disconnectNotifications() {
  return () => {
    sseNotificationService.disconnect();
    connectionToastManager.reset();
    document.removeEventListener('click', unlockAudio);
    document.removeEventListener('keydown', unlockAudio);
  };
}

